import { render } from "./ViewPersonalAccount.vue?vue&type=template&id=e5740fb6"
import script from "./ViewPersonalAccount.vue?vue&type=script&lang=js"
export * from "./ViewPersonalAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__